import mapRowsToOptions from '@pluto/map-to-options';

const getOptions = (data: any) => {
    if (!data || !data.length) {
        return [];
    }
    
    return data.map(mapRowsToOptions);
};

export default getOptions;
